import { ProjectItem } from './projects';
import { toProjectSlug } from '../utils/projectSlug';
import { blogPosts } from './blogPosts';

// Project slug -> blog slug.
export const projectWriteups: Record<string, string> = {
  'stateless-desktops': 'stateless',
  piper: 'piper',
  'boostos-ai': 'boostos',
  harnessgg: 'harness',
  'agentic-personal-assistant': 'april',
};

export type ProjectWorkLabel = 'Writing' | 'Experiment' | 'Project';

export const getProjectWorkLabel = (project: ProjectItem): ProjectWorkLabel => {
  const slug = toProjectSlug(project);
  if (projectWriteups[slug] || project.externalWriteupTitle) return 'Writing';
  return project.workType ?? 'Project';
};

export const getProjectDestination = (project: ProjectItem): string => {
  const slug = toProjectSlug(project);
  const writeup = projectWriteups[slug];

  if (writeup) {
    return `/${writeup}`;
  }

  if (slug === 'baselayer' && project.liveSite) {
    return project.liveSite;
  }

  return project.github || project.liveSite || `/projects/${slug}`;
};

export const getProjectDate = (period: string): string =>
  period.split(/\s+[–—-]\s+/)[0].trim();

// Entries that have a writeup are listed under its title rather than the
// project name, whether the writeup lives on this site or somewhere else.
export const getProjectWorkTitle = (project: ProjectItem): string => {
  const writeup = projectWriteups[toProjectSlug(project)];
  const post = writeup
    ? blogPosts.find((blogPost) => blogPost.slug === writeup)
    : undefined;
  return post?.title ?? project.externalWriteupTitle ?? project.title;
};

const MONTH_LABELS = [
  'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June',
  'July', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.',
];

export const getProjectWorkDate = (project: ProjectItem): string => {
  const writeup = projectWriteups[toProjectSlug(project)];
  const post = writeup
    ? blogPosts.find((blogPost) => blogPost.slug === writeup)
    : undefined;

  if (post) {
    const [year, month] = post.date.split('-').map(Number);
    if (year && month) {
      return `${MONTH_LABELS[month - 1]} ${year}`;
    }
  }

  return getProjectDate(project.period);
};
